const initProductHeading = () => {
    const productHeadingComponentList = document.querySelectorAll("[data-simple-heading-component]");
    iframeVideoBackground(productHeadingComponentList);
};
